import { DsSynopticsXData } from './ds-synoptics-x-data';
import { DsSynopticsRowInterface } from '../interfaces/ds-synoptics-row.interface';
import { DsSynopticsGenericObject } from './ds-synoptics-generic-object';

export class DsSynopticsRow extends DsSynopticsGenericObject {
  /**
   * List of data to display on the X axis of the synoptics. Can represent a form template, xData the form instances with their start and end KPs.
   */
  public xData?: DsSynopticsXData[];

  /**
   * Creates an instance of DsSynopticsRow.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsSynopticsRowInterface) {
    super(jsonData);
    if (!jsonData) {
      return;
    }
    this.xData = jsonData.xData ? jsonData.xData.map((xData) => new DsSynopticsXData(xData)) : [];
  }
}
